<style scoped lang="scss">
.desc-p {
}
.report-type-section {
  .report-type-section-inner {
    display: flex;
    flex-direction: column;
    .report-type-section-inner-detail {
      flex: 1 1 auto;
    }
  }
  ul {
    list-style: none;
    li {
      font-size: 18px;
      line-height: 24px;
    }
  }
}
</style>

<template>
  <div class="uk-form" v-if="application && application.household">
    <div class="uk-grid" v-if="!print">
      <div class="uk-width-medium-3-5 uk-push-1-5 uk-margin-large-bottom">
        <div class="uk-panel-box"><strong>{{ __('tenant.inc_understanding_adjusted_gross') }}</strong> <small><br class="uk-margin-bottom"/>
<!--          {{ __('tenant.inc_understanding_adjusted_gross_content') }}-->
        </small>
        </div>

        <div class="uk-panel-box" v-if="programSettings['uses-same-method-income']"><strong>{{ __('tenant.inc_everyone_must') }}</strong> <span v-html="__('tenant.inc_you_select_1040', {required_days: programSettings['required-days-of-income-proof']})"></span>
        </div>

      </div>
    </div>
    <div class="uk-grid uk-width-1-1">
      <div class="uk-width-1-1 uk-margin-large-bottom" v-if="shouldShowMember(member)" v-for="(member, i) in household.members" :key="member.id">
        <legend>{{ member.first_name }} {{ member.last_name }}</legend>

        <div class="uk-grid">
          <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-width-large-1-3 uk-margin-bottom">
            <label>Select {{ member.first_name }}'s Proof of Income Type</label>
            <validated-section :field="`income_type_${member.id}`" :errors="errors">
              <select :value="householdMembersWithIncome[member.id].incomeProofType" @change="onIncomeTypeChange($event.target.value, member.id)" class="uk-select uk-width-1-1">
                <option :value="null">{{ __('tenant.make_a_selection') }}</option>
                <option value="1040">{{ __(`tenant.inc_last_year_1040`) }}</option>
                <option value="w2-1099" v-if="householdMembersWithIncome[member.id].incomeProofType === 'w2-1099' || programSettings['uses-income-history-documents']">{{ __(`tenant.inc_last_year_w2`) }}</option>
                <option value="last-days">{{ __(`tenant.inc_last_days`, {required_days: programSettings['required-days-of-income-proof']}) }}</option>
                <option v-if="i === 0 && programSettings['uses-income-attestation-option']" value="attestation">{{ __(`tenant.inc_attestation`) }}</option>
                <option v-if="programSettings['uses-no-income-option']" value="none">{{ __('tenant.inc_no_income') }}</option>
              </select>
            </validated-section>
          </div>

          <div class="uk-width-1-1 uk-margin-top" v-if="householdMembersWithIncome[member.id].incomeProofType === null || !householdMembersWithIncome[member.id].incomeProofType">
            <div class="uk-grid report-type-section">
              <div class="uk-width-medium-1-1">
                <h2 class="uk-card-title">{{ __('tenant.inc_using_your_tax', {year: application.tax_year}) }}</h2>
                <h3 class="uk-h3">{{ __('tenant.inc_best_option', {year: application.tax_year}) }}</h3>

                <ul>
                  <li><i class="a-circle-checked"></i> {{ __('tenant.inc_uses_adjusted') }}</li>
                  <li><i class="a-circle-checked"></i> {{ __('tenant.inc_certify_once') }}</li>
                  <li><i class="a-circle-checked"></i> {{ __('tenant.inc_one_document') }}</li>
                </ul>

                <h3 class="uk-h3">{{ __('tenant.inc_using_taxes_allows', {year: application.tax_year}) }}</h3>

                <div class="uk-card-footer">
                  <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, '1040')" >{{ __('tenant.inc_lets_use_filing', {year: application.tax_year}) }}</button>
                </div>
              </div>
            </div>
            <div class="uk-grid uk-margin-large-top report-type-section">
              <div class="report-type-section-inner" :class="reportGridItemWidthClass" v-if="householdMembersWithIncome[member.id].incomeProofType === 'w2-1099' || programSettings['uses-income-history-documents']">
                <div class="report-type-section-inner-detail">
                  <h2 class="uk-card-title">{{ __('tenant.inc_have_w2', {year: application.tax_year}) }}</h2>
                  <h3 class="uk-h3">{{ __('tenant.inc_highly_recommend') }}</h3>
                  <h3 class="uk-h3 uk-margin-top"> <a href="https://www.irs.gov/filing/free-file-do-your-federal-taxes-for-free" target="_blank">{{ __('tenant.inc_file_for_free') }}</a></h3>
                </div>

                <div class="uk-card-footer">
                  <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'w2-1099')" >{{ __('tenant.inc_upload_proof_income') }}</button>
                </div>
              </div>
              <div class="report-type-section-inner" :class="reportGridItemWidthClass">
                <div class="report-type-section-inner-detail">
                  <h2 class="uk-card-title">{{ __('tenant.inc_have_last_days', {required_days: programSettings['required-days-of-income-proof']}) }}</h2>
                  <h3 class="uk-h3">{{ __('tenant.inc_have_last_days_desc', {required_days: programSettings['required-days-of-income-proof']}) }}</h3>
                  <ul>
                    <li><i class="a-circle-checked"></i> {{ __('tenant.inc_have_last_days_1') }}</li>
                    <li><i class="a-circle-checked"></i> {{ __('tenant.inc_have_last_days_2', {required_days: programSettings['required-days-of-income-proof']}) }}</li>
                    <li><i class="a-circle-checked"></i> {{ __('tenant.inc_have_last_days_3') }}</li>
                  </ul>
                </div>


                <div class="uk-card-footer">
                  <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'last-days')" >{{ __('tenant.inc_use_last_x_days', {days: programSettings['required-days-of-income-proof']}) }}</button>
                </div>
              </div>
              <div class="report-type-section-inner" :class="reportGridItemWidthClass" v-if="programSettings['uses-no-income-option']">
                <div class="report-type-section-inner-detail">
                  <h2 class="uk-card-title">{{ __('tenant.inc_i_have_no_income') }}</h2>
                  <h3 class="uk-h3">{{ __('tenant.inc_i_have_no_income_1') }}</h3>
                  <h3 class="uk-h3">{{ __('tenant.inc_i_have_no_income_2') }}</h3>
                  <h3 class="uk-h3">{{ __('tenant.inc_i_have_no_income_3') }}</h3>
                </div>

                <div class="uk-card-footer">
                  <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'none')" >{{ __('tenant.inc_have_no_income') }}</button>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === '1040'">
            <irs1040-entry-form
                :members="household.members"
                :member="member"
                :label="member.first_name + ' ' + member.last_name"
                :url="uploadUrl"
                @includedMembersChanged="updatedIncludedMembers"
                @updated="onMemberIncomeChanged"
                :ref="`irs1040Form_${member.id}`"
            ></irs1040-entry-form>
          </div>

          <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'w2-1099'">
            <w2-or1099-entry-form
                @updated="onMemberIncomeChanged"
                :member="member"
                :label="member.first_name + ' ' + member.last_name"
                :url="uploadUrl"
                :ref="`w2Form_${member.id}`"
            ></w2-or1099-entry-form>

          </div>

          <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'last-days'">
            <income-entry-form
                @updated="onMemberIncomeChanged"
                :values="householdMembersWithIncome[member.id].incomeValues"
                :member="member"
                :members="household.members"
                :label="member.first_name + ' ' + member.last_name"
                :url="uploadUrl"
                :ref="`lastDaysForm_${member.id}`"
            ></income-entry-form>
          </div>

          <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'none'">
            <NoIncomeHHForm
                :members="household.members"
                :member="member"
                :label="member.first_name + ' ' + member.last_name"
                :url="uploadUrl"
                :ref="`noIncomeHHForm_${member.id}`"
                @confirmSelect="onMemberIncomeSelected"
            >
            </NoIncomeHHForm>
          </div>

          <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'attestation'">
            <income-attestation-type
                :members="household.members"
                :member="member"
                :label="member.first_name + ' ' + member.last_name"
                :ref="`incomeAttestationForm_${member.id}`"
                @updated="onMemberIncomeChanged"
                @onSignatureUpdated="onSignatureUpdated"
                @declined="declineAttestation"
                @noIncome="declineAttestationNoIncome"
            ></income-attestation-type>
          </div>
        </div>
      </div>
      <div class="uk-width-1-1 uk-margin-top" v-if="!hasHouseholdEarners && programSettings['use-income-amount-in-no-income']">
        <hr/>
        <div class="uk-grid uk-margin-top">
          <div class="uk-width-1-1">
            <p>
              {{ __('tenant.inc_declare_no_one_income') }}
            </p>
          </div>
          <div class="uk-width-1-1">
            <table class="uk-table uk-hidden-small uk-table-striped">
              <thead>
              <tr>
                <th>{{ __('tenant.inc_monthly_expense') }}</th>
                <th v-if="programSettings['no-income-uses-monthly-amount']">{{ __('tenant.inc_monthly_amount') }}</th>
                <th>{{ __('tenant.inc_how_get_paid') }}</th>
                <th v-if="programSettings['no-income-uses-contact-name']">{{ __('tenant.inc_who_pays') }}</th>
                <th v-if="programSettings['no-income-uses-contact-phone']">{{ __('tenant.inc_contact_phone') }}</th>
                <th v-if="programSettings['no-income-uses-contact-email']">{{ __('tenant.inc_contact_email') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="incomeValue in zeroIncomeValues">
                <td>{{ incomeValue.label }}</td>
                <td v-if="programSettings['no-income-uses-monthly-amount']">
                  <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                </td>
                <td>
                  <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                    <option :value="null">Select a method</option>
                    <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                  </select>
                </td>
                <td v-if="programSettings['no-income-uses-contact-name']">
                  <input type="text" v-model="incomeValue.payer">
                </td>
                <td v-if="programSettings['no-income-uses-contact-phone']">
                  <input type="text" v-model="incomeValue.payer_phone">
                </td>
                <td v-if="programSettings['no-income-uses-contact-email']">
                  <input type="text" v-model="incomeValue.payer_email">
                </td>
              </tr>
              </tbody>
            </table>

            <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked" v-for="incomeValue in zeroIncomeValues">
              <div class="uk-width-1-1">
                <h4>
                  {{ incomeValue.label }}
                </h4>
              </div>
              <div class="uk-width-1-2 uk-margin-top uk-margin-bottom">
                <div class="uk-form-row" v-if="programSettings['no-income-uses-monthly-amount']">
                  <label class="uk-form-label" for="">{{ __('tenant.inc_monthly_amount') }}</label>
                  <div class="uk-form-controls">
                    <div>
                      <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                    </div>
                  </div>
                </div>
                <div class="uk-form-row" v-if="programSettings['no-income-uses-contact-name']">
                  <label class="uk-form-label" for="">{{ __('tenant.inc_who_pays') }}</label>
                  <div class="uk-form-controls">
                    <div>
                      <input type="text" v-model="incomeValue.payer">
                    </div>
                  </div>
                </div>
                <div class="uk-form-row" v-if="programSettings['no-income-uses-contact-phone']">
                  <label class="uk-form-label" for="">{{ __('tenant.inc_contact_phone') }}</label>
                  <div class="uk-form-controls">
                    <div>
                      <input type="text" v-model="incomeValue.payer_phone">
                    </div>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-2 uk-margin-top uk-margin-large-bottom">
                <div class="uk-form-row">
                  <label class="uk-form-label" for="">{{ __('tenant.inc_how_get_paid') }}</label>
                  <div class="uk-form-controls">
                    <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                      <option :value="null">{{ __('tenant.inc_select_method') }}</option>
                      <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                    </select>
                  </div>
                </div>
                <div class="uk-form-row" v-if="programSettings['no-income-uses-contact-email']">
                  <label class="uk-form-label" for="">{{ __('tenant.inc_contact_email') }}</label>
                  <div class="uk-form-controls">
                    <div>
                      <input type="text" v-model="incomeValue.payer_email">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1">
            <p v-html="__(`tenant.inc_under_penalty`,{program: program['program_name'], agency: program['agency_short_name'], program_abbreviation: program['program_abbreviation'], agency_short_name: program['agency_short_name']})"></p>
            <div class="uk-width-1-1 uk-margin-top" v-if="programSettings['uses-esign-whole-household-no-income']">
              <validated-section :field="`signature_no_income_${applicant.id}`" :errors="errors">
                <signature-box @updated="onSignatureUpdated"
                               :user-key="applicant.id"
                               :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at"
                               :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
                               :name="applicant.first_name + ' ' + applicant.last_name"
                               :color="programSettings['primary-program-color']"
                ></signature-box>
              </validated-section>
            </div>
            <div class="uk-width-1-1 uk-margin-top" v-else>
              <DocRequest
                  :applicationId="application.id"
                  :member="member"
                  :incomes="zeroIncomeValues"
                  docType="no-income-entire-hh"
              ></DocRequest>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-1 uk-margin-large-top">
        <validated-section :errors="errors" field="income_amount" style="text-align: right;">
          <h2 class="uk-text-right">{{ __('tenant.inc_total_annualized') }}: {{ totalRequested | formatMoney }}</h2>
        </validated-section>
      </div>
    </div>
    <modal-dialog
        :title="__('tenant.inc_are_you_sure')"
        ref="confirmIncomeTypeModal"
        @close="onCloseModalConfirm"
        @confirm="onCompleteModalConfirm"
        confirmText="Confirm"
        :stuck="true"
    >
      {{ __('tenant.inc_are_you_sure_text') }}
    </modal-dialog>
  </div>
</template>

<script>
import IncomeEntryForm from "../../../../../components/AppWizard/Step3/IncomeEntryFormV4";
import { mapState, mapGetters } from 'vuex';
import Irs1040EntryForm from "../../../../../components/AppWizard/Step3/Irs1040EntryForm";
import W2Or1099EntryForm from "../../../../../components/AppWizard/Step3/W2Or1099EntryForm";
import NoIncomeHHForm from "../../../../../components/AppWizard/Step3/NoIncomeHHForm";
import ModalDialog from "../../../../../components/Common/ModalDialog";
import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
import ValidatedSection from "../../../../../components/Common/ValidatedSection";
import DocRequest from "../../../../../components/AppWizard/Step3/DocRequest";
import IncomeAttestationType from "../../../../../components/AppWizard/Step3/IncomeAttestationType";
import accounting from 'accounting';

export default {
  name: "Step3",
  components: {
    IncomeAttestationType,
    W2Or1099EntryForm,
    Irs1040EntryForm,
    IncomeEntryForm,
    ModalDialog,
    ValidatedSection,
    SignatureBox,
    DocRequest,
    NoIncomeHHForm,
  },
  props: {
    print: {
      default: false,
    }
  },
  data() {
    return {
      errors: {},
      signatureData: {},
      uploadUrl: "api/hope/documents",
      showTypeChangeAlertModal: false,
      primaryApplicantHasIncome: false,
      primaryApplicantIncomeValues: [],
      householdMembersWithIncome: {},
      zeroIncomePaymentMethods: {
        gift: 'Gift',
        loan: 'Loan',
        other: 'Other',
      },
      zeroIncomeValues: [
        {
          name: 'family_clothing',
          label: 'Family Clothing',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
        {
          name: 'rent',
          label: 'Rent',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
        {
          name: 'utilities',
          label: 'Utilities',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
        {
          name: 'internet',
          label: 'Internet',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
        {
          name: 'medical-dental-care',
          label: 'Medical / Dental Care',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
        {
          name: 'medications',
          label: 'Medications & Prescriptions',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
        {
          name: 'phone',
          label: 'Cell Phone / Phone',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
        {
          name: 'food',
          label: 'Food',
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        },
      ],

      hhMemberIdsIncludedInOtherDocs: {},
      incomeTypes: {
        '1040': [ '1040' ],
        'last-days': [ 'primary_monthly','secondary_monthly','tertiary_monthly','self_employment_monthly','service_pay','operation_business','self-employment','worker-compensation','interest','unemployment-benefit','ssi','annuities','insurance','alimony','regular_contribution','tanf','all_regular_pay' ],
        'w2-1099': [ 'w2', 'k1', '1099-A', '1099-B', '1099-C', '1099-CAP', '1099-DIV', '1099-G', '1099-INT', '1099-K', '1099-LTC', '1099-MISC', '1099-OID', '1099-PATR', '1099-Q', '1099-R', '1099-SA' ],
        'none': [ 'none' ],
        'attestation': ['attestation'],
      }
    }
  },
  watch: {
    application(newValue) {
      if(newValue.household) {
        this.initData();
      }
    },
  },
  computed: {
    reportGridItemWidthClass() {
      if (this.programSettings['uses-income-history-documents'])
        return 'uk-width-medium-1-3'
      return 'uk-width-medium-1-2'
    },

    currentYear() {
      return (new Date()).getFullYear()
    },

    hasHouseholdEarners() {
      let hasEarners = false;
      if(this.primaryApplicantHasIncome) {
        hasEarners = true;
      }
      for(let i in this.householdMembersWithIncome) {
        let member = this.householdMembersWithIncome[i];
        if(member.incomeProofType !== null && member.incomeProofType !== 'none') {
          hasEarners = true;
        }
      }
      return hasEarners;
    },
    household() {
      if(this.application && this.application.household) {
        return this.application.household;
      }
    },
    totalRequested() {
      let total = 0;
      _.each(this.householdMembersWithIncome, member => {
        if (member.incomeValues)
        {
          const values = member.incomeValues.filter(item => this.incomeTypes[member.incomeProofType] && this.incomeTypes[member.incomeProofType].includes(item.type))
          _.each(values, income => {
            total += this.getAnnualIncomeFromIncomeValue(income)
          })
        }
      })
      return total;
    },
    ...mapState('App', {
      env: state => state.env,
      permissions: state => state.permissions,
    }),
    ...mapState('Application', {
      assets: state => state.assets,
      application: state => state.application,
      applicant: state => state.applicant,
      signatures: state => state.applicant.signatures,
      lmi: state => state.lmi,
    }),
    ...mapGetters('Application', [ 'program', 'programSettings' ]),
  },
  mounted() {
    if(this.household) {
      this.initData();
    }
  },
  methods: {
    generateZeroIncomeList() {
      this.zeroIncomeValues = _.map(this.assets.zeroIncomeTypes, type => {
        return {
          name: type.name,
          label: type.label,
          amount: 0,
          method: null,
          payer: '',
          payer_phone: '',
          payer_email: '',
        }
      })
    },
    onSignatureUpdated($event) {
      if(!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(this.signatureData, $event.key, {typeKey: $event.typeKey, signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
    },

    onCloseModalConfirm(data) {
      const {id, oldVal, newVal } = data
      setTimeout(() => {
        this.changeProofType(id, oldVal)
      }, 100)
    },

    onCompleteModalConfirm(data) {
      const {id, oldVal, newVal } = data
      this.changeProofType(id, newVal)
    },

    onIncomeTypeChange(value, id, showModal = true) {

      if (this.householdMembersWithIncome[id].incomeProofType !== value)
      {
        if (this.householdMembersWithIncome[id].incomeProofType && showModal)
        {
          this.$refs.confirmIncomeTypeModal.setData({
            id: id,
            oldVal: this.householdMembersWithIncome[id].incomeProofType,
            newVal: value,
          })

          this.$refs.confirmIncomeTypeModal.open();
        } else {
          this.changeProofType(id, value)
        }
      }
      this.$nextTick(this.$forceUpdate);
    },

    changeProofType(id, value) {
      this.hhMemberIdsIncludedInOtherDocs = {};
      this.householdMembersWithIncome[id]['incomeValues'] = [];
      if (this.programSettings['uses-same-method-income'] && value !== 'none')
      {
        _.each(this.householdMembersWithIncome, (item, idx) => {
          if (item.incomeProofType != 'none' || idx == id)
          {
            item.incomeProofType = value
          }
        })
      } else {
        this.householdMembersWithIncome[id].incomeProofType = value
      }
    },

    onTypeButtonClick(id, type) {
      this.changeProofType(id, type)
    },

    shouldShowMember(member) {

      // If the HoH has attestation set, do not show any members other than the head of household
      let hoh = _.first(this.household.members);
      if(this.householdMembersWithIncome[hoh.id] && this.householdMembersWithIncome[hoh.id].incomeProofType === 'attestation') {
        return member.id === hoh.id;
      }

      const memberId = parseInt(member.id);
      let isIncluded = false;
      for(var i in this.hhMemberIdsIncludedInOtherDocs) {
        if(this.hhMemberIdsIncludedInOtherDocs[i].includes(memberId)) {
          isIncluded = true
          break;
        }
      }
      return !isIncluded && this.householdMembersWithIncome[memberId] && this.ageForMember(member) >= 18;
    },

    updatedIncludedMembers(payload) {
      if(payload.memberIds.length === 0) {
        this.$set(this.hhMemberIdsIncludedInOtherDocs, payload.fromMember, []);
      }else {
        if(this.hhMemberIdsIncludedInOtherDocs[payload.fromMember] === undefined) {
          this.$set(this.hhMemberIdsIncludedInOtherDocs, payload.fromMember, []);
        }
        this.hhMemberIdsIncludedInOtherDocs[payload.fromMember] = payload.memberIds;
      }
      payload.memberIds.forEach(mId => {
        if (!this.householdMembersWithIncome[mId])
          this.householdMembersWithIncome[mId] = {}
        this.householdMembersWithIncome[mId]['incomeValues'] = [];
      });
    },
    initData() {
      this.generateMembersArray();
      this.generateZeroIncomeList();
      _.each(this.application.zero_income_meta, meta => {
        _.each(this.zeroIncomeValues, value => {
          if(meta.name === value.name) {
            value.amount = meta.amount;
            value.method = meta.method;
            value.payer = meta.payer;
            value.payer_phone = meta.payer_phone;
            value.payer_email = meta.payer_email;
          }
        })
      })

      this.signatureData = {}

      const signatureFiltered = this.signatures && this.signatures.find(item => item.key === `no-income-entire-hh`)
      if(signatureFiltered) {
        this.$set(this.signatureData, this.applicant.id, { signed_at: signatureFiltered.created_at, completed: true });
      }

      // If program has a setting to default to income attestation, use it.
      if(this.programSettings['uses-income-attestation-option'] && this.programSettings['income-attestation-prequal-question'] !== 0) {
        let questionNumber = this.programSettings['income-attestation-prequal-question'];
        if(this.application.prequal_answers[questionNumber-1] === 'yes') {
          let member = _.first(this.household.members);
          if(!this.householdMembersWithIncome[member.id] || this.householdMembersWithIncome[member.id].incomeProofType === "" || this.householdMembersWithIncome[member.id].incomeProofType === null) {
            if (!this.householdMembersWithIncome[member.id])
              this.householdMembersWithIncome[member.id] = {}
            this.householdMembersWithIncome[member.id].incomeProofType = 'attestation';
          }
        }
      }


    },

    declineAttestation() {
      let member = _.first(this.household.members);
      this.$refs.confirmIncomeTypeModal.setData({
        id: member.id,
        oldVal: this.householdMembersWithIncome[member.id].incomeProofType,
        newVal: null,
      })
      this.$refs.confirmIncomeTypeModal.open();
      // this.$set(this.householdMembersWithIncome[member.id], 'incomeProofType', null);
      // this.onIncomeTypeChange(null, member.id);
    },
    declineAttestationNoIncome() {
      let member = _.first(this.household.members);
      this.$refs.confirmIncomeTypeModal.setData({
        id: member.id,
        oldVal: this.householdMembersWithIncome[member.id].incomeProofType,
        newVal: 'none',
      })
      this.$refs.confirmIncomeTypeModal.open();
      // this.$set(this.householdMembersWithIncome[member.id], 'incomeProofType', null);
      // this.onIncomeTypeChange(null, member.id);
    },

    generateMembersArray() {
      this.householdMembersWithIncome = {};
      _.each(this.household.members, member => {
        // get age
        let dob = moment(member.birth_date);
        let age = moment().diff(dob, 'years');
        if(age < 18) return;

        let incomeType = member.income_type;
        if(incomeType == "none" && !this.programSettings['uses-no-income-option']) {
          incomeType = null;
        }

        this.$set(this.householdMembersWithIncome, member.id, {
          hasIncome: member.annual_income !== null && member.annual_income > 0,
          incomeValues: member.incomes,
          incomeProofType: incomeType,
        });
      })
    },

    scrollTop: function () {
      if (window.pageYOffset > 0) {
        this.intervalId = setInterval(() => {
          if (window.pageYOffset === 0) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 50)
        }, 5)
      }
    },

    async setApplicationAsIneligible() {
      // Update status to the over limit status id
      let data = {
        application: {
          zero_income: this.hasHouseholdEarners ? 0 : 1,
          zero_income_meta: (this.hasHouseholdEarners) ? null : JSON.stringify(this.zeroIncomeValues),
          signatureData: this.signatureData
        },
        members: this.getHouseholdMemberData(),
      }
      let res = await axios.put(`/api/hope/applications/${this.application.id}/step-3-over-income`, data);
      if(!this.permissions.pm && !this.permissions.processor) {
        window.location.reload();
      }else {
        this.$store.dispatch('Application/fetch', this.application.id)
      }
    },

    async validateStep() {
      let stepValid = false;
      this.errors = {};



      const subFormValid = await this.checkFormValid();
      if (subFormValid) {
        await this.save();
        stepValid = true
      }

      // Check total income vs ami
      let incomeOverLimitStatusId = this.programSettings['income-over-limit-status-id'];
      let formattedLmi = accounting.formatMoney(this.lmi);
      let formattedAmount = accounting.formatMoney(this.totalRequested);
      let householdSize = this.application.household.members.length;
      let modalText = `Are you sure your income is correct? When annualized it is "${formattedAmount}". <br/><br/> The maximum amount allowed for your household size of ${householdSize} is ${formattedLmi}`;
      if(this.programSettings['show-income-confirmation-modal-always']) {
        this.$emit('loading', false)
        try {
          await UIkit.modal.confirm(modalText);
          if(incomeOverLimitStatusId && this.lmi && this.totalRequested > this.lmi) {
            await this.setApplicationAsIneligible();
          }
        }catch(e) {
          return false;
        }
      }else if(incomeOverLimitStatusId && this.lmi && this.totalRequested > this.lmi) {
        this.$emit('loading', false)
        try {
          await UIkit.modal.confirm(modalText);
          await this.setApplicationAsIneligible();
        }catch (e) {
          this.$set(this.errors, 'income_amount', { errors: 'You must select an amount lower than the LMI of ' + accounting.formatMoney(this.lmi) + ' to continue.'});
        }
        return false;
      }

      if (!this.hasHouseholdEarners && this.programSettings['uses-esign-whole-household-no-income'])
      {
        if (this.programSettings['use-income-amount-in-no-income'])
        {
          if(!this.signatureData[this.applicant.id]) {
            this.errors['signature_no_income_' + this.applicant.id] = {
              errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
            };
          }else if(this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
            this.errors['signature_no_income_' + this.applicant.id] = {
              errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
            };
          }
        }
      }

      _.each(this.householdMembersWithIncome, (member, id) => {
        const hhMember = this.household.members.find(item => item.id == id)
        let vMember = {
          ...member,
          id,
          birth_date: hhMember ? hhMember.birth_date: null,
        }
        if(!member.incomeProofType && this.shouldShowMember(vMember))
        {
          const userName = hhMember ? hhMember.first_name + ' ' + hhMember.last_name : 'User'
          this.errors['income_type_' + id] = {
            errors: [userName + ' must select an option below.'],
          };
        }
      })
      let errorCount = _.size(this.errors);

      if(errorCount > 0) stepValid = false;

      !stepValid &&  this.scrollTop()

      window.applicationsLoaded = false

      return stepValid
    },
    async save() {

      let data = {
        application: {
          zero_income: this.hasHouseholdEarners ? 0 : 1,
          zero_income_meta: (this.hasHouseholdEarners) ? null : JSON.stringify(this.zeroIncomeValues),
          signatureData: this.signatureData
        },
        members: this.getHouseholdMemberData(),
      }

      return axios.put(`/api/hope/applications/${this.application.id}/step-3`, data)
          .then((res) => {
            this.$store.dispatch('Application/fetch', this.application.id)
          })
          .catch((error) => {
          })
    },

    async checkFormValid() {

      let isValid = true;
      _.each(this.householdMembersWithIncome, (member, id) => {
        let refForm = undefined

        switch (member.incomeProofType) {
          case '1040':
            if (this.$refs[`irs1040Form_${id}`])
              refForm = this.$refs[`irs1040Form_${id}`][0]
            break;
          case 'w2-1099':
            if (this.$refs[`w2Form_${id}`])
              refForm = this.$refs[`w2Form_${id}`][0]
            break;
          case 'last-days':
            if (this.$refs[`lastDaysForm_${id}`])
              refForm = this.$refs[`lastDaysForm_${id}`][0]
            break;
          case 'attestation':
            if (this.$refs[`incomeAttestationForm_${id}`])
              refForm = this.$refs[`incomeAttestationForm_${id}`][0]
            break;
          case 'none':
            if (this.$refs[`noIncomeHHForm_${id}`])
              refForm = this.$refs[`noIncomeHHForm_${id}`][0]
            break;
          default:
            break;
        }

        if (refForm && typeof refForm['validate'] === 'function')
        {
          isValid = isValid && refForm.validate();
        }

      });
      return isValid;
    },

    getHouseholdMemberData() {
      let data = {}
      let index = 0;
      _.each(this.householdMembersWithIncome, (member, id) => {
        let refForm = undefined
        let incomes = []
        let signatureData = {}

        switch (member.incomeProofType) {
          case '1040':
            if (this.$refs[`irs1040Form_${id}`])
              refForm = this.$refs[`irs1040Form_${id}`][0]
            incomes = refForm ? [refForm.income]: [];
            signatureData = refForm ? refForm.signatureData: {};
            break;
          case 'w2-1099':
            if (this.$refs[`w2Form_${id}`])
              refForm = this.$refs[`w2Form_${id}`][0]
            incomes = refForm ? refForm.incomes: [];
            signatureData = refForm ? refForm.signatureData: {};
            break;
          case 'last-days':
            if (this.$refs[`lastDaysForm_${id}`])
              refForm = this.$refs[`lastDaysForm_${id}`][0]
            incomes = refForm ? refForm.incomes: [];
            signatureData = refForm ? refForm.signatureData: {};
            break;
          case 'none':
            if (this.$refs[`noIncomeHHForm_${id}`])
              refForm = this.$refs[`noIncomeHHForm_${id}`][0]
            signatureData = refForm ? refForm.signatureData: {};
            break;
          case 'attestation':
            if (this.$refs[`incomeAttestationForm_${id}`])
              refForm = this.$refs[`incomeAttestationForm_${id}`][0]
            signatureData = refForm ? refForm.signatureData: {};
            incomes = refForm ? refForm.incomes: [];
            break;
          default:
            break;
        }

        data[id] = {
          annual_income: this.getTotalRequestedForMember(member),
          annual_income_meta: member.incomeValues,
          incomes: incomes,
          signatureData: signatureData,
          ...member
        }
        index++;
      })
      return data;
    },

    ageForMember(member) {
      if (member && member.birth_date)
        return moment().diff(moment(member.birth_date), 'years');
      return 0
    },
    checkboxUpdated() {
      window.setTimeout(() => this.$forceUpdate(), 200);
      // this.$nextTick(this.$forceUpdate);
    },

    getTotalRequestedForMember(member) {
      let total = 0;
      _.each(member.incomeValues, income => {
        total += this.getAnnualIncomeFromIncomeValue(income)
      })
      return total;
    },

    getAnnualIncomeFromIncomeValue(income) {
      let amount = income.income_amount
      let arr = ['paystub', 'attestation', 'none']

      if (arr.includes(income.doc_type))
      {
        let incomeAssets = income.doc_type === 'paystub' ? income.paystubs : income.attestations
        if(income.type === 'attestation') {
          amount = income.income_amount;
        }else {
          amount = _.reduce(incomeAssets, (sum, item) => {
            return sum + item.income_amount
          }, 0);
          amount = incomeAssets.length ? amount / incomeAssets.length : 0;
        }

        switch(income.interval) {
          case 'monthly':
          case 'other':
            amount = parseFloat(amount) * 12;
            break;

          case 'weekly':
            amount = parseFloat(amount) * 52;
            break;

          case 'biweekly':
            amount = parseFloat(amount) * 26;
            break;

          case 'bimonthly':
            amount = parseFloat(amount) * 24;
            break;

          case 'annually':
            amount = parseFloat(amount);
            break;

          default: amount = parseFloat(amount) * 12;
            break;
        }
      }

      return amount ? amount:  0;

    },

    getTotalRequested() {
      let total = 0;
      _.each(this.householdMembersWithIncome, member => {
        _.each(member.incomes, income => {
          total += this.getAnnualIncomeFromIncomeValue(income)
        })
      })
      return total;
    },

    onMemberIncomeSelected($event) {
      let member = $event.member;
      this.onIncomeTypeChange('last-days', member.id, false)
    },

    onMemberIncomeChanged($event) {
      this.householdMembersWithIncome[$event.member.id]['incomeValues'] = $event.amounts;
      this.householdMembersWithIncome[$event.member.id]['signatureData'] = $event.signatureData ? $event.signatureData : {};
      this.$nextTick(this.$forceUpdate);
    },
    onApplicantIncomeChanged($event) {
      this.primaryApplicantIncomeValues = $event.amounts;
      this.$nextTick(this.$forceUpdate);
    },
    MonthlyTotalIncome() {
      var totalMonthlyIncome = 0;
      var monthlyGrossWagesPrimaryJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-primary-job"]').val());
      /// ADD IN VARS DYNAMICALLY FOR EACH APPLICANT ADDED ON SECTION 2 FOR GRAND TOTAL ///

      var monthlyGrossWagesSecondJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-second-job"]').val());
      var monthlyGrossWagesThirdJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-third-job"]').val());
      var selfEmployment = parseInt($('#financial-information-form').find('input[name="self-employment"]').val());
      var alimony = parseInt($('#financial-information-form').find('input[name="alimony"]').val());
      var socialSecurityIncome = parseInt($('#financial-information-form').find('input[name="social-security-income"]').val());
      var socialSecurityDisability = parseInt($('#financial-information-form').find('input[name="social-security-disability"]').val());
      var unemploymentCompensation = parseInt($('#financial-information-form').find('input[name="unemployment-compensation"]').val());
      var otherGovernmentAssistance = parseInt($('#financial-information-form').find('input[name="other-government-assistance"]').val());
      var retirement = parseInt($('#financial-information-form').find('input[name="retirement"]').val());
      var annuityInvestment = parseInt($('#financial-information-form').find('input[name="annuity-investment"]').val());
      var rentFromRoommate = parseInt($('#financial-information-form').find('input[name="rent-from-roommate"]').val());
      var rentalPropertyIncome = parseInt($('#financial-information-form').find('input[name="rental-property-income"]').val());
      var contributionsFromFamilyOrFriends = parseInt($('#financial-information-form').find('input[name="contributions-from-family-or-friends"]').val());
      var other = parseInt($('#financial-information-form').find('input[name="other"]').val());
      totalMonthlyIncome = monthlyGrossWagesPrimaryJob + monthlyGrossWagesSecondJob + monthlyGrossWagesThirdJob + selfEmployment + alimony + socialSecurityIncome + socialSecurityDisability + unemploymentCompensation + otherGovernmentAssistance + retirement + annuityInvestment + rentFromRoommate + rentalPropertyIncome + contributionsFromFamilyOrFriends + other;
      $('#financial-information-form').find('input[name="total-monthly-income"]').val(totalMonthlyIncome);

    }
  }
}
</script>
